import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import DeleteModal from "components/Common/DeleteModal"
import FundCodeListComponent from "components/FundCode/list"
import {
  deleteFundCode,
  exportFundCodes,
  getFundCodes,
} from "store/fund-code/fund-code-action"

const FundCodeList = () => {
  const dispatch = useDispatch()
  const { data, loading, exportStatus } = useSelector(state => state.fundCode)
  const [deleteModal, setDeleteModal] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(10)
  const [according, setAccording] = useState({ order: "desc", name: "id" })

  const handleDeleteFunc = () => {
    if (selectedRecord) {
      dispatch(deleteFundCode(selectedRecord.id))
    }
    setDeleteModal(false)
  }

  const onClickDelete = data => {
    setSelectedRecord(data)
    setDeleteModal(true)
  }

  const onPageClick = link => {
    dispatch(getFundCodes(link.url, pageNumber, according, search))
  }

  const onSearchHandler = value => {
    setSearch(value)
  }

  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => ({ ...prev, order: value.order }))
    }
    if (value.name) {
      setAccording(prev => ({ ...prev, name: value.name }))
    }
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      dispatch(getFundCodes(undefined, undefined, undefined, search))
    }, 1500)

    return () => clearTimeout(delayDebounceFn)
  }, [search])

  useEffect(() => {
    dispatch(getFundCodes(undefined, pageNumber, according, search))
  }, [pageNumber, according])

  const onExportBtnClick = () => {
    dispatch(exportFundCodes(search))
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteFunc}
        onCloseClick={() => setDeleteModal(false)}
      />

      <Breadcrumbs title={"Admin"} breadcrumbItem={"Fund Codes"} />
      <FundCodeListComponent
        data={data}
        loading={loading}
        onClickDelete={onClickDelete}
        onPageClick={onPageClick}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onExportBtnClick={onExportBtnClick}
        exportStatus={exportStatus}
      />
    </React.Fragment>
  )
}

export default FundCodeList
